import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { PermissionGroupListMaintenanceDto } from './PermissionGroupListMaintenanceDto';
import { PermissionGroupItemMaintenanceDto } from './PermissionGroupItemMaintenanceDto';
import { BaseMaintenanceController } from '../_base/BaseMaintenanceController';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Observable } from 'rxjs';
import { UserListMaintenanceDto } from '../user/UserListMaintenanceDto';

@Injectable()
export class PermissionGroupMaintenanceController extends
    BaseMaintenanceController<PermissionGroupListMaintenanceDto, PermissionGroupItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "system/securityandnotifications/permissiongroup");
    }


    public getResourceRoot(): string {
        return "PERMISSION.GROUP";
    }

    public buildUrl(uri: string): string {
        return "/system/securityandnotifications/permissiongroup" + uri;
    }
}
